<template>
  <div class="MyFollow">
    <div class="PageCommon">
      <div class="bscroll" ref="bscroll">
        <div class="bscroll-container">
          <h3 class="pageTitle">
            <span v-if="!mobileFlag">
              {{ $t("Menu_Followers_FollowingList") }}
            </span>
            <div class="refreshListBtnDiv">
              <el-button class="confirmDialogBtn" @click="refreshList()">
                {{ $t("Common_Operation_Refresh") }}
                <i class="el-icon-refresh-right"></i>
              </el-button>
            </div>
          </h3>

          <div class="tableDiv" v-if="!mobileFlag">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              ref="dataTable"
              :summary-method="getSummaries"
              show-summary
            >
              <el-table-column
                width="80"
                v-if="!mobileFlag"
                :fixed="tableData.length !== 0 ? true : false"
                prop="sortNum"
                :label="$t('Common_TableTitle_Number')"
              >
              </el-table-column>
              <el-table-column
                :fixed="tableData.length !== 0 ? true : false"
                width="100"
                prop="account"
                :label="$t('Common_TableTitle_Mt4Account')"
              >
                <template slot-scope="scope">
                   <!-- <div v-if="scope.row.status == 1 || scope.row.status == 4" class="mt4Click"> -->
                  <div v-if="scope.row.status == 1 || scope.row.status == 4" >
                    {{ scope.row.mtType }}.{{ scope.row.account }}
                  </div>
                  <div v-else>
                   -
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :width="flexLabelWidth($t('Common_TableTitle_SignalSource'))"
                prop="portfolioName"
                :label="$t('Common_TableTitle_SignalSource')"
              >
              </el-table-column>
              <el-table-column
                :width="
                  flexLabelWidth($t('Common_TableTitle_SignalSourceEmail'))
                "
                prop="portfolioLoginId"
                :label="$t('Common_TableTitle_SignalSourceEmail')"
              >
              </el-table-column>
              <el-table-column
                prop="beginPeriodEquity"
                :label="$t('Common_TableTitle_InitialEquity')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.beginPeriodEquity
                        ? formatNumberFractionDigits(
                            scope.row.beginPeriodEquity
                          )
                        : 0.0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="currentPeriodDeposit"
                :label="$t('Common_TableTitle_CurrentPeriodDeposit')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.currentPeriodDeposit
                        ? formatNumberFractionDigits(
                            scope.row.currentPeriodDeposit
                          )
                        : 0.0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="equity"
                :label="$t('Common_TableTitle_CurrentEquity')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.equity
                        ? formatNumberFractionDigits(scope.row.equity)
                        : 0.0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="balance"
                :label="$t('Common_TableTitle_Balance')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.balance
                        ? formatNumberFractionDigits(scope.row.balance)
                        : 0.0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :width="flexLabelWidth($t('Common_TableTitle_CurrentProfitLoss'))"
                prop="profit"
                :label="$t('Common_TableTitle_CurrentProfitLoss')"
              >
                <template slot-scope="scope">
                  <div :class="scope.row.profit > 0 ? 'greenNum' : 'redNum'">
                    {{
                      scope.row.profit
                        ? formatNumberFractionDigits(scope.row.profit)
                        : 0.0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :width="flexLabelWidth($t('Common_TableTitle_MarginLevel'))"
                prop="marginLevel"
                :label="$t('Common_TableTitle_MarginLevel')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.marginLevel ? scope.row.marginLevel + "%" : 0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :width="flexLabelWidth($t('Common_TableTitle_FreeMargin'))"
                prop="freeMargin"
                :label="$t('Common_TableTitle_FreeMargin')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.freeMargin
                        ? formatNumberFractionDigits(scope.row.freeMargin)
                        : 0
                    }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                :width="
                  flexLabelWidth($t('Common_TableTitle_CurrentPeriodVolumes'))
                "
                prop="currentPeriodVolumes"
                :label="$t('Common_TableTitle_CurrentPeriodVolumes')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.currentPeriodVolumes
                        ? scope.row.currentPeriodVolumes
                        : 0
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="160"
                prop="currentSettlementBeginTime"
                :label="$t('Common_TableTitle_CurrentBeginTime')"
              >
              </el-table-column>
              <el-table-column
                width="160"
                prop="currentSettlementEndTime"
                :label="$t('Common_TableTitle_CurrentEndTime')"
              >
              </el-table-column>
              <el-table-column
                :label="$t('Common_TableTitle_Status')"
                :fixed="tableData.length !== 0 ? 'right' : false"
              >
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.status == 0" class="statusGreen">{{
                      $t("Common_InvitationStatus_BeInvited0")
                    }}</span>
                    <span v-if="scope.row.status == 1" class="statusYellow">{{
                      $t("Common_InvitationStatus_Agree1")
                    }}</span>
                    <span v-if="scope.row.status == 2" class="statusRed">{{
                      $t("Common_InvitationStatus_Refuse2")
                    }}</span>
                    <span v-if="scope.row.status == 3" class="statusRed">
                      {{ $t("Common_InvitationStatus_Stop3") }}
                    </span>
                    <span v-if="scope.row.status == 4" class="statusYellow">{{
                      $t("Common_InvitationStatus_AgreeWatingActivate4")
                    }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                :fixed="tableData.length !== 0 ? 'right' : false"
                v-if="!mobileFlag"
                width="180"
                :label="$t('Common_TableTitle_Operation')"
              >
                <template slot-scope="scope">
                  <div class="operateBtns">
                    <el-button
                      v-if="scope.row.status == 1 || scope.row.status == 4"
                      @click="getSetting(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="SettingIcon"
                      ></svg-icon>
                      {{ $t("Common_Setting") }}
                    </el-button>
                    <el-button
                      v-if="scope.row.status == 1 || scope.row.status == 4"
                      @click="stopFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="StopIcon"
                      ></svg-icon>
                      {{ $t("Common_Operate_StopFollow") }}
                    </el-button>
                    <el-button
                      v-if="scope.row.status == 0"
                      @click="checkFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="CheckIcon"
                      ></svg-icon>
                      {{ $t("Common_Operation_ViewInvitation") }}
                    </el-button>
                    <span v-if="scope.row.status == 2"> - </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :fixed="tableData.length !== 0 ? 'right' : false"
                v-if="mobileFlag"
                width="80"
                :label="$t('Common_TableTitle_Operation')"
              >
                <template slot-scope="scope">
                  <div class="operateBtns">
                    <el-popover placement="bottom-end" trigger="click">
                      <el-button
                        v-if="scope.row.status == 1 || scope.row.status == 4"
                        @click="getSetting(scope.row)"
                        type="text"
                        size="small"
                        v-loading.fullscreen.lock="fullscreenLoading"
                      >
                        <svg-icon
                          class="greenIcon"
                          icon-class="SettingIcon"
                        ></svg-icon>
                        {{ $t("Common_Setting") }}
                      </el-button>
                      <el-button
                        v-if="scope.row.status == 1 || scope.row.status == 4"
                        @click="stopFollow(scope.row)"
                        type="text"
                        size="small"
                        v-loading.fullscreen.lock="fullscreenLoading"
                      >
                        <svg-icon
                          class="greenIcon"
                          icon-class="StopIcon"
                        ></svg-icon>
                        {{ $t("Common_Operate_StopFollow") }}
                      </el-button>
                      <el-button
                        v-if="scope.row.status == 0"
                        @click="checkFollow(scope.row)"
                        type="text"
                        size="small"
                        v-loading.fullscreen.lock="fullscreenLoading"
                      >
                        <svg-icon
                          class="greenIcon"
                          icon-class="CheckIcon"
                        ></svg-icon>
                        {{ $t("Common_Operation_ViewInvitation") }}
                      </el-button>
                      <span v-if="scope.row.status == 2"> - </span>
                      <i
                        slot="reference"
                        class="mobileSetting el-icon-setting"
                      ></i>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="tableTotalNum">
              {{
                $t("Common_TableTotalvolumns") +
                " : " +
                totalVolume +
                "&nbsp;&nbsp;&nbsp;&nbsp;" +
                $t("Common_TableTotalprofit") +
                " : " +
                totalProfit +
                " "
              }}
            </div>
            <el-pagination
              class="tablePage"
              :prev-text="$t('Common_PreviousPage')"
              :next-text="$t('Common_NexPage')"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              @size-change="handleSizeChange"
              :page-sizes="[5, 10, 20, 50, 100]"
              :pager-count="5"
              :page-size="pageSize"
              layout="prev, pager, next, sizes"
              :total="total"
            >
            </el-pagination>
          </div>

          <div class="mobileTableList" v-show="mobileFlag">
            <div class="tableTotalTop">
              <span>{{ $t("Common_TableTotalvolumns") }}</span>
              <b>
                {{ totalVolume }}
              </b>
            </div>
            <div class="tableTotalTop">
              <span>{{ $t("Common_TableTotalprofit") }}</span>
              <b :class="[totalProfit > 0 ? 'greenNum' : 'redNum']">
                {{ totalProfit }}
              </b>
            </div>
            <el-collapse accordion @change="collapseChange">
              <el-collapse-item v-for="(item, index) in tableData" :key="index">
                <template slot="title">
                  <div class="mobileTableCard" @click.stop="showCollapse()">
                    <div class="mobileTableItem mobileTableStatusTitle">
                      <div>
                        <span v-if="item.status == 0" class="statusGreen">{{
                          $t("Common_InvitationStatus_BeInvited0")
                        }}</span>
                        <span v-if="item.status == 1" class="statusYellow">{{
                          $t("Common_InvitationStatus_Agree1")
                        }}</span>
                        <span v-if="item.status == 2" class="statusRed">{{
                          $t("Common_InvitationStatus_Refuse2")
                        }}</span>
                        <span v-if="item.status == 3" class="statusRed">
                          {{ $t("Common_InvitationStatus_Stop3") }}
                        </span>
                        <span v-if="item.status == 4" class="statusYellow">{{
                          $t("Common_InvitationStatus_AgreeWatingActivate4")
                        }}</span>
                      </div>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_Mt4Account") }}
                      </p>
                      <!-- class="mobileTableContent mobileUnderline" -->
                      <p
                        v-if="item.status == 1 || item.status == 4"
                        class="mobileTableContent "
                      >
                         {{ item.mtType }}.{{ item.account }}
                      </p>
                      <p v-else class="mobileTableContent">
                        -
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_SignalSource") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.portfolioName }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_SignalSourceEmail") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.portfolioLoginId }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_InitialEquity") }}
                      </p>
                      <p class="mobileTableContent">
                        {{
                          item.beginPeriodEquity
                            ? formatNumberFractionDigits(item.beginPeriodEquity)
                            : 0.0
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="mobileTableBtns" @click.stop="showCollapse()">
                    <el-button
                      class="mobileBlueBtn"
                      v-if="item.status == 1 || item.status == 4"
                      @click="getSetting(item)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="SettingIcon"
                      ></svg-icon>
                      {{ $t("Common_Setting") }}
                    </el-button>
                    <el-button
                      class="mobileBlueBtn"
                      v-if="item.status == 1 || item.status == 4"
                      @click="stopFollow(item)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="StopIcon"
                      ></svg-icon>
                      {{ $t("Common_Operate_StopFollow") }}
                    </el-button>
                    <el-button
                      class="mobileBlueBtn"
                      v-if="item.status == 0"
                      @click="checkFollow(item)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="CheckIcon"
                      ></svg-icon>
                      {{ $t("Common_Operation_ViewInvitation") }}
                    </el-button>
                  </div>
                </template>
                <div class="mobileTableCard">
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_CurrentPeriodDeposit") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.currentPeriodDeposit
                          ? formatNumberFractionDigits(
                              item.currentPeriodDeposit
                            )
                          : 0.0
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_CurrentEquity") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.equity
                          ? formatNumberFractionDigits(item.equity)
                          : 0.0
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_Balance") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.balance
                          ? formatNumberFractionDigits(item.balance)
                          : 0.0
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_ProfitLoss") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.profit
                          ? formatNumberFractionDigits(item.profit)
                          : 0.0
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_MarginLevel") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.marginLevel ? item.marginLevel + "%" : 0 }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_FreeMargin") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.freeMargin
                          ? formatNumberFractionDigits(item.freeMargin)
                          : 0.0
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_CurrentPeriodVolumes") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.currentPeriodVolumes
                          ? item.currentPeriodVolumes
                          : 0
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_CurrentBeginTime") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.currentSettlementBeginTime }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_CurrentEndTime") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.currentSettlementEndTime }}
                    </p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>

            <div class="x" v-if="up && tableData.length < total">
              <i class="el-icon-loading"></i>
              {{ $t("Common_Loading") }}
            </div>
            <div class="x" v-if="!up && tableData.length >= total">
              {{ $t("Common_NoMoreData") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      :title="followDrawerTitle"
      class="drawerCommon checkInviteDrawer"
      :append-to-body="true"
      @close="closeDrawer()"
      :close-on-press-escape="false"
      :visible.sync="checkInviteDrawer"
      direction="rtl"
    >
      <div class="drawerContent">
        <el-form
          :model="followForm"
          :rules="followRule"
          ref="followForm"
          label-width="150px"
          class="drawerForm"
          :label-position="mobileFlag ? 'top' : 'right'"
        >
          <h3 class="checkInviteDrawerTitle">
            <i></i> {{ $t("ViewInvitation_ParameterSetting") }}
          </h3>
          <el-form-item prop="following">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_CopyRatio") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_CopyRatio'),
                      $t('ViewInvitation_CopyPercentTxt'),
                      $t('ViewInvitation_CopyPercentTxt1')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>

                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i>
                  <div>
                    <div>
                      {{ $t("ViewInvitation_CopyPercentTxt") }}
                    </div>
                    <br />
                    <div>
                      {{ $t("ViewInvitation_CopyPercentTxt1") }}
                    </div>
                  </div>
                </div>
              </span>
            </span>
            <div class="formPercentDiv">
              <el-input
                :disabled="checkRow.status !== 1"
                v-model.number="followForm.following"
                autocomplete="off"
              ></el-input>
              <b
                :class="
                  checkRow.status !== 1 ? 'formPercent' : 'formPercentStatus'
                "
                >%</b
              >
              <div class="formPercentSetting" @click="percentSetting">
                {{ $t("Common_Setting") }}
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="maxVolume">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_MaxLot") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_MaxLot'),
                      $t('ViewInvitation_MaxVolumnTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i>
                  <div>
                    <div>
                      {{ $t("ViewInvitation_MaxVolumnTxt") }}
                    </div>
                    <br />
                    <div>
                      {{ $t("ViewInvitation_MaxVolumnTxt1") }}
                    </div>
                  </div>
                </div>
              </span>
            </span>
            <el-input-number
              disabled
              class="creaseInput"
              controls-position="right"
              v-model.number="followForm.maxVolume"
              :placeholder="$t('Common_TR_VolumeNotLimit')"
              autocomplete="off"
            ></el-input-number>
            <b class="formLots">lots</b>
          </el-form-item>
          <el-form-item :label="$t('Common_TableTitle_Instruments')">
            <el-input disabled v-model="followForm.symbols"></el-input>
          </el-form-item>
          <el-form-item prop="autoRecon">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_AutoMatchOrder") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_AutoMatchOrder'),
                      $t('ViewInvitation_IsAutoTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i
                  >{{ $t("ViewInvitation_IsAutoTxt") }}
                </div>
              </span>
            </span>
            <el-radio-group v-model="followForm.autoRecon" disabled>
              <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
              <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            prop="activation"
            :label="$t('Common_TableTitle_ActivationStatus')"
          >
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_ActivationStatus") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_ActivationStatus'),
                      $t('ViewInvitation_MainActiveTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i
                  >{{ $t("ViewInvitation_MainActiveTxt") }}
                </div>
              </span>
            </span>
            <el-radio-group v-model="followForm.activation" disabled>
              <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
              <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <h3 class="checkInviteDrawerTitle">
            <i></i>{{ $t("Setting_SetUpmyCopyAccount") }}
          </h3>
          <el-form-item :label="$t('Common_Mt4BrokerName')" prop="brokerName">
            <el-select
              :disabled="isFollowing"
              v-model="followForm.brokerName"
              class="drawer_100Input"
              @change="selectChange"
            >
              <el-option
                v-for="item in brokerList"
                :key="item.id"
                :label="item.brokerName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Common_Mt4Account')" prop="account">
            <el-input
              :disabled="isFollowing"
              v-model="followForm.account"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="checkRow.status == 0"
            :label="$t('Common_Mt4Password')"
            prop="cwPassword"
          >
            <el-input
              type="password"
              v-model="followForm.cwPassword"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Common_Mt4Server')" prop="serverId">
            <el-select
              v-model="followForm.serverId"
              class="allLengthInput"
              :disabled="isFollowing"
            >
              <el-option
                v-for="item in serverList"
                :key="item.serverId"
                :label="item.serverName"
                :value="item.serverId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Setting_OneClickToClose')"
            v-if="checkRow.status == 1"
          >
            <div class="drawerCard">
              <el-form-item>
                <div class="drawerCardItem">
                  <span class="drawerCard_Label drawerCard_LabelWidth">{{
                    $t("Setting_ChooseOrder")
                  }}</span>
                  <el-select
                    class="drawerCard_100Input"
                    v-model="followForm.orderType"
                  >
                    <el-option :label="$t('Common_All')" :value="0"></el-option>
                    <el-option
                      :label="$t('Setting_Cmd_Sell')"
                      :value="2"
                    ></el-option>
                    <el-option
                      :label="$t('Setting_Cmd_Buy')"
                      :value="1"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="drawerCardItem">
                  <span class="drawerCard_Label drawerCard_LabelWidth">{{
                    $t("Setting_PL")
                  }}</span>
                  <el-select
                    class="drawerCard_100Input"
                    v-model="followForm.profitType"
                  >
                    <el-option :label="$t('Common_All')" :value="0"></el-option>
                    <el-option
                      :label="$t('Setting_PL_Sell')"
                      :value="1"
                    ></el-option>
                    <el-option
                      :label="$t('Setting_PL_Buy')"
                      :value="2"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="drawerCardBtns">
                  <el-button class="drawerCardBtn" @click="closeOrder()">{{
                    $t("Common_Operate_ClosePosition")
                  }}</el-button>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
        </el-form>
        <div class="drawerBtns" v-if="checkRow.status == 0">
          <el-button
            class="confirmDialogBtn"
            v-loading.fullscreen.lock="fullscreenLoading"
            @click="followSubmit(1)"
            >{{ $t("ViewInvitation_AcceptInvitation") }}</el-button
          >

          <el-button class="cancelDialogBtn" @click.stop="isRefuse = true">{{
            $t("ViewInvitation_RejectInvitation")
          }}</el-button>
        </div>
        <div class="refuseCard" v-if="isRefuse" ref="refuseCard">
          <p v-if="mobileFlag">
            {{ $t("ViewInvitation_RejectInvitation") }}
          </p>
          <el-input
            type="textarea"
            :rows="6"
            :placeholder="$t('ViewInvitation_RejectInvitation_DEMO')"
            v-model="refuseReason"
          >
          </el-input>
          <el-button class="confirmDialogBtn" @click="followSubmit(2)">{{
            $t("Common_Complete")
          }}</el-button>
        </div>
      </div>
    </el-drawer>
    <div class="mobileLabelTips" ref="mobileLabelTips" v-if="isLableTips">
      <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
      <p>
        {{ labelTitle }}
      </p>
      <div>
        <div>
          {{ labelTxt }}
        </div>
        <br />
        <div v-if="labelSubContent">
          {{ labelSubContent }}
        </div>
      </div>
    </div>
    <PopupTips
      :popupVisible="isPopupVisible"
      :icon="iconImg"
      :title="$t('Common_Prompt')"
      @confirmPopupTips="confirmPopup"
      @cancelPopupTips="cancelPopup"
      @cancelClosePopupTips="cancelClosePopup"
      ref="popupTipsRef"
      :isShowClose="isShowClose"
      :confirmTxt="confirmTxt"
      :cancelTxt="cancelTxt"
      :isHtml="isHtml"
      :fullscreenLoading="fullscreenLoading"
      :subContent="$t(subContent)"
      :content="$t(popupContent)"
      :btnType="btnType"
    />

    <el-dialog
      :title="$t(stopDialogTitle)"
      @close="cancelStop()"
      :visible.sync="stopDialogVisible"
      class="closeCheckDialog"
      width="40%"
      top="5vh"
    >
      <el-form
        :model="stopForm"
        ref="stopForm"
        :label-position="mobileFlag ? 'top' : 'left'"
        @submit.native.prevent
        label-width="150px"
      >
        <el-form-item
          :label="$t('Common_TableTitle_BeginTime')"
          prop="currentSettlementBeginTime"
        >
          <el-input
            disabled
            v-model="stopForm.currentSettlementBeginTime"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_InitialEquity')"
          prop="beginPeriodEquity"
        >
          <el-input
            disabled
            v-model="stopForm.beginPeriodEquity"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_CurrentPeriodDeposit')"
          prop="currentPeriodDeposit"
        >
          <el-input
            disabled
            v-model="stopForm.currentPeriodDeposit"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Settlement_SettlementEquity')"
          prop="endPeriodEquity"
        >
          <el-input
            disabled
            v-model="stopForm.endPeriodEquity"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('Common_TableTitle_PLSharingRatio')"
          prop="shareProfitPercent"
        >
          <el-input
            disabled
            v-model="stopForm.shareProfitPercent"
            placeholder="0-100"
          ></el-input>
          <b class="formPercent">%</b>
        </el-form-item>
        <el-form-item
          prop="bouns"
          :label="$t('Settlement_PaymentProfitSharingMoney')"
        >
          <el-input
            disabled
            v-model="stopForm.bouns"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="status"
          :label="$t('Settlement_ProfitSharingInstructions')"
        >
          <div>
            {{ $t("Settlement_ProfitSharingInstructionsOne") }}
          </div>
          <div>
            {{ $t("Settlement_ProfitSharingInstructionsTwo") }}
          </div>
          <div>
            {{ $t("Settlement_ProfitSharingInstructionsThree") }}
          </div>
        </el-form-item>
      </el-form>
      <hr />
      <el-checkbox class="stopCheckbox" v-model="stopCheckbox">{{
        $t("Settlement_StopCheckTxt")
      }}</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button class="confirmDialogBtn" @click="stopSubmit()">{{
          $t("Common_Confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  concatParams,
  concatTableData,
  dateGmt8,
} from "../../plugins/common.js";
import { mapState } from "vuex";
import PopupTips from "@/components/moudule/PopupTips.vue";
import load2 from "@/components/moudule/Loading.vue";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";
BScroll.use(Pullup);

export default {
  name: "MyFollow",
  components: {
    PopupTips,
    load2,
  },
  computed: {
    ...mapState(["checkPortfolio", "userInfo", "token", "mobileFlag"]),
  },
  data() {
    let checkMt4 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("Common_Valid_CheckMt4Account")));
      } else if (
        !Number.isInteger(Number(value)) ||
        value.length < 5 ||
        value.length > 10
      ) {
        callback(new Error(this.$t("Common_Valid_CheckMt4AccountNum")));
      } else {
        callback();
      }
    };
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 5,
      historyCurrentPage: 1,
      historyTotal: 0,
      historyPageSize: 5,
      checkInviteDrawer: false,
      fullscreenLoading: false,
      followForm: {
        account: "",
        following: 0,
        signalMaxDrawdown: 0,
        takeProfit: 0,
        maxDrawdown: 0,
        maxVolume: 0,
        symbols: "",
        autoRecon: true,
        activation: true,
        maxDrawdownStopFollow: false,
        takeProfitStopFollow: false,
        orderType: 0,
        profitType: 0,
        cwPassword: "",
        serverId: 0,
        brokerName: "",
      },
      followRule: {
        account: [{ validator: checkMt4, trigger: "change" }],
        cwPassword: [
          {
            required: true,
            message: this.$t("Common_Valid_Mt4PasswordNotNull"),
            trigger: "blur",
          },
        ],
      },
      checkRow: {},
      refuseReason: "",
      isRefuse: false,
      isFollowing: false,
      followDrawerTitle: "",
      activeName: "follow",
      historyTableData: [],
      labelTitle: "",
      labelTxt: "",
      isLableTips: false,
      accountList: [],
      isPopupVisible: false,
      iconImg: require("../../assets/images/NotifyWarning.svg"),
      isStopPopupVisible: false,
      isClosePopupVisible: false,
      btnType: 1,
      popupTitle: "",
      popupContent: "",
      clickType: "",
      cancelTxt: "Common_Cancel",
      confirmTxt: "Common_Confirm",
      isShowClose: false,
      totalProfit: 0,
      totalVolume: 0,
      brokerList: [],
      serverList: [],
      isHtml: false,
      subContent: "",
      labelSubContent: "",
      up: false,
      firstOpen: false,
      stopDialogVisible: false,
      stopForm: {
        bouns: "",
        currentPeriodDeposit: "",
        currentSettlementBeginTime: "",
        shareProfitPercent: "",
        beginPeriodEquity: "",
      },
      stopDialogTitle: "",
      stopCheckbox: false,
      isFormPercentSettingPopupVisible: true,
    };
  },
  watch: {},
  mounted() {
    this.$refs.popupTipsRef.rendered = true;
  },
  created() {
    this.getData(this.currentPage,this.pageSize);
    this.screenClick();
    this.getServeList();
  },
  methods: {
    formatNumberFractionDigits,
    refreshList() {
      this.currentPage = 1;
      this.getData(this.currentPage,this.pageSize);
    },

    collapseChange() {
      this.$nextTick(() => {
        if (!this.firstOpen) {
          this.scroll.maxScrollY = this.scroll.maxScrollY - 250;
          this.firstOpen = true;
        } else {
          this.scroll.maxScrollY = this.scroll.maxScrollY + 250;
          this.firstOpen = false;
        }
      });
    },
    showCollapse() {},
    scrollFn() {
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.bscroll, {
            click: true,
            scrollY: true,
            probeType: 3,
          });
        } else {
          this.scroll.refresh();
        }

        //touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
        this.scroll.on("touchEnd", (pos) => {
          //上拉加载 总高度>下拉的高度+10 触发加载更多
          if (this.scroll.maxScrollY > pos.y + 10) {
            this.up = true;
            setTimeout(() => {
              //使用refresh 方法 来更新scroll  解决无法滚动的问题
              if (this.tableData.length < this.total) {
                this.currentPage = this.currentPage + 1;
                this.getData("noRefresh");
                this.scroll.refresh();
                this.up = false;
              } else {
                this.up = false;
              }
            }, 1000);
          }
        });
      });
    },
    getServeList() {
      this.$axios.get("/Api/invite/BrokerList").then((res) => {
        let dt = res.data;
        if (dt.isSuccess) {
          this.brokerList = dt.result;
        }
      });
    },
    cancelPopup(val) {
      this.isPopupVisible = val;
      this.cancelTxt = "Common_Cancel";
      this.confirmTxt = "Common_Confirm";
      this.isShowClose = false;
      this.subContent = "";
      if (this.clickType == "stopCopy" && this.checkRow.status == 1) {
        this.cancelStopPopup();
      }
    },
    confirmPopup(val) {
      this.isPopupVisible = val;
      this.cancelTxt = "Common_Cancel";
      this.confirmTxt = "Common_Confirm";
      this.subContent = "";
      this.isShowClose = false;
      if (this.clickType == "noChange") {
        this.allowSubmit();
      } else if (this.clickType == "stopCopy") {
        this.confirmStopPopup();
      } else if (this.clickType == "closeOrder") {
        this.confirmCloseOrder();
      } else if (this.clickType == "percentSetting") {
        this.confirmPercentSetting();
      }
    },
    getData(pageIndex, pageSize, tag) {
      const loading = this.$loading({
        lock: true,
      });
      if (!this.mobileFlag || tag !== "noRefresh") {
        this.tableData = [];
      }
      var params = {
        status: this.$route.query.status ? this.$route.query.status : "",
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      this.$axios.get("/Api/Invite/List" + concatParams(params)).then((res) => {
        let dt = res.data;

        if (dt.isSuccess) {
          this.total = dt.result.total;
          this.totalProfit = dt.result.totalProfit;
          this.totalVolume = dt.result.totalVolume;
          if (this.mobileFlag && tag == "noRefresh") {
            dt.result.pageList.forEach((item) => {
              this.tableData.push(item);
            });
          } else {
            this.tableData = concatTableData(
              dt.result.pageList,
              dt.result.total,
              this.currentPage,
              this.pageSize
            );
          }

          this.fullscreenLoading = false;
          if (this.mobileFlag) {
            this.scrollFn();
          }
        }
      }).finally(()=>{
        loading.close();
      });
    },
    // 查看邀请
    checkFollow(row) {
     const loading = this.$loading({
        lock: true,
      });
      this.isFollowing = false;
      this.isRefuse = false;
      this.checkRow = row;
      this.followDrawerTitle = this.$t("MyFollowers_ViewInvitation");
      var params = {
        id: row.id,
      };
      this.$axios
        .get("/Api/Invite/GetInvite" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.checkInviteDrawer = true;
            this.$nextTick(function () {
              this.followForm = Object.assign(this.followForm, dt.result);
              this.followForm.forexSelectLabel = this.followForm.forexSelect
                ? this.$t("Common_Fx")
                : "";
              this.followForm.energySelectLabel = this.followForm.energySelect
                ? this.$t("Common_Energy")
                : "";
              this.followForm.metalsSelectLabel = this.followForm.metalsSelect
                ? this.$t("Common_Metal")
                : "";
              this.followForm.indicesSelectLabel = this.followForm.indicesSelect
                ? this.$t("Common_Indices")
                : "";
              this.followForm.cryptoSelectLabel = this.followForm.cryptoSelect
                ? this.$t("Common_Crypto")
                : "";
              this.followForm.symbols =
                this.followForm.forexSelectLabel +
                " " +
                this.followForm.energySelectLabel +
                " " +
                this.followForm.metalsSelectLabel +
                " " +
                this.followForm.indicesSelectLabel +
                " " +
                this.followForm.cryptoSelectLabel;
              this.followForm.maxVolume =
                this.followForm.maxVolume == 0
                  ? undefined
                  : this.followForm.maxVolume;
            });
          } else {
            this.$notify.error({
              title: this.$t("Common_Setting"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
          loading.close();
        });
    },
    // 设置
    getSetting(row) {
       const loading = this.$loading({
        lock: true,
      });
      this.isFollowing = true;
      this.checkRow = row;
      this.isRefuse = false;
      this.followDrawerTitle = this.$t("Common_Setting");
      var params = {
        id: row.id,
      };
      this.$axios
        .get("/Api/Invite/GetSetting" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.checkInviteDrawer = true;
            this.$nextTick(function () {
              this.brokerList.forEach((item) => {
                if (dt.result.brokerName == item.brokerName) {
                  this.selectChange(item.id);
                }
              });
              this.followForm = Object.assign(this.followForm, dt.result);
              this.followForm.forexSelectLabel = this.followForm.forexSelect
                ? this.$t("Common_Fx")
                : "";
              this.followForm.energySelectLabel = this.followForm.energySelect
                ? this.$t("Common_Energy")
                : "";
              this.followForm.metalsSelectLabel = this.followForm.metalsSelect
                ? this.$t("Common_Metal")
                : "";
              this.followForm.indicesSelectLabel = this.followForm.indicesSelect
                ? this.$t("Common_Indices")
                : "";
              this.followForm.cryptoSelectLabel = this.followForm.cryptoSelect
                ? this.$t("Common_Crypto")
                : "";
              this.followForm.symbols =
                this.followForm.forexSelectLabel +
                " " +
                this.followForm.energySelectLabel +
                " " +
                this.followForm.metalsSelectLabel +
                " " +
                this.followForm.indicesSelectLabel +
                " " +
                this.followForm.cryptoSelectLabel;
              this.followForm.maxVolume =
                this.followForm.maxVolume == 0
                  ? undefined
                  : this.followForm.maxVolume;
              this.followForm.orderType = 0;
              this.followForm.profitType = 0;
            });
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
          loading.close();
        });
    },
    closeDrawer() {
      this.$refs.followForm.resetFields();
      this.checkInviteDrawer = false;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage, this.pageSize);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage, this.pageSize);
    },
    followSubmit(status) {
   
      if (status == 1) {
        this.$refs.followForm.validate((valid) => {
          if (valid) {
            this.btnType = 1;
            this.clickType = "noChange";
            this.popupTitle = "ViewInvitation_NoChangePassword";
            this.popupContent = "ViewInvitation_NoChangePasswordContent";
            this.isPopupVisible = true;
          }
        });
       
      } else {
        this.fullscreenLoading = true;
        var params = {
          id: this.checkRow.id,
          status: status,
          refuseReason: this.refuseReason,
        };
      const loading = this.$loading({
        lock: true,
      });
        this.$axios
          .post("/Api/Invite/PostInvite", params)
          .then((res) => {
            let dt = res.data;
            if (dt.isSuccess) {
              this.$notify.success({
                title: this.$t("Common_Prompt"),
                message: this.$t("Common_OperateSuccess"),
              });

              this.getData(this.currentPage, this.pageSize);
              this.$refs.followForm.resetFields();
              this.checkInviteDrawer = false;
              this.refuseReason = "";
            } else {
              this.$notify.error({
                title: this.$t("Common_Prompt"),
                message: dt.result,
              });
            }
          })
          .finally(() => {
            this.fullscreenLoading = false;
             loading.close();
          });
      }
    },
    //同意邀请
    allowSubmit() {
      this.fullscreenLoading = true;
      var params = {
        id: this.checkRow.id,
        account: this.followForm.account,
        cwPassword: this.followForm.cwPassword,
        serverId: this.followForm.serverId,
        status: 1,
      };
      this.$axios
        .post("/Api/Invite/PostInvite", params)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.getData();
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
            this.$refs.followForm.resetFields();
            this.checkInviteDrawer = false;
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    // 设置保存  暂时取消
    followSettingSave(type) {
      this.fullscreenLoading = true;
      var setValue = 0;
      if (type == 1) {
        if (this.followForm.maxDrawdown) {
          setValue = this.followForm.maxDrawdown;
        } else {
          setValue = 0;
        }
      } else {
        if (this.followForm.takeProfit) {
          setValue = this.followForm.takeProfit;
        } else {
          setValue = 0;
        }
      }
      var params = {
        id: this.checkRow.id,
        setValue: setValue,
        type: type,
      };
      this.$axios
        .post("/Api/Invite/PostSetting", params)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            this.getData(this.currentPage, this.pageSize);
            this.checkInviteDrawer = false;
            this.$refs.followForm.resetFields();
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    //// 一键平仓确认走接口
    confirmCloseOrder() {
      this.fullscreenLoading = true;
      var params = {
        inviteId: this.checkRow.id,
        orderType: Number(this.followForm.orderType),
        profitType: Number(this.followForm.profitType),
      };
      this.$axios
        .get("/Api/Invite/CloseOrder" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            this.getData(this.currentPage, this.pageSize);
            this.checkInviteDrawer = false;
            this.$refs.followForm.resetFields();
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    // 一键平仓
    closeOrder() {
      this.btnType = 2;
      this.clickType = "closeOrder";
      this.popupTitle = "Setting_CloseOrderTitle";
      this.popupContent = "Setting_CloseOrderContent";
      this.subContent = "Setting_StopCopingContent1";
      this.isHtml = true;
      this.isPopupVisible = true;
    },
    stopFollow(row) {
          const loading = this.$loading({
           lock: true,
        });
      if (row.status == 1) {
        this.btnType = 2;
        this.stopDialogTitle = "Common_Operate_StopFollow";
        this.isShowClose = true;
        this.stopDialogVisible = true;
        this.checkRow = row;
     
        this.$axios
          .get("/Api/invite/StopFollowDetail?inviteId=" + row.id)
          .then((res) => {
            let dt = res.data;
            if (dt.isSuccess) {
              this.stopForm = dt.result;
              this.stopForm.currentPeriodDeposit = formatNumberFractionDigits(
                this.stopForm.currentPeriodDeposit
              );
              this.stopForm.beginPeriodEquity = formatNumberFractionDigits(
                this.stopForm.beginPeriodEquity
              );
              this.stopForm.endPeriodEquity = formatNumberFractionDigits(
                this.stopForm.endPeriodEquity
              );
            }
          }).finally(()=>{
            loading.close();
          });
      } else {
        this.btnType = 2;
        this.clickType = "stopCopy";
        this.popupTitle = "Common_Operate_StopFollow";
        this.popupContent = "Common_Operate_StopCopingConfirm";
        this.cancelTxt = "Common_Cancel";
        this.confirmTxt = "Common_Confirm";
        this.isShowClose = false;
        this.isPopupVisible = true;
        this.checkRow = row;
        loading.close();
      }

      // });
    },
    // 停止跟随 选择是
    confirmStopPopup(val) {
      const loading = this.$loading({
        lock: true,
      });
      var params = {
        id: this.checkRow.id,
        closeOrder: 1,
      };
      this.$axios
        .get("/Api/Invite/StopFollow" + concatParams(params))
        .then((res) => {
          let dt = res.data;

          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    // 停止跟随 选择否
    cancelStopPopup() {
      const loading = this.$loading({
        lock: true,
      });
      var params = {
        id: this.checkRow.id,
        closeOrder: 0,
      };
      this.$axios
        .get("/Api/Invite/StopFollow" + concatParams(params))
        .then((res) => {
          let dt = res.data;

          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          loading.close();
          this.stopDialogVisible = false;
        });
    },
    // 停止跟随关闭
    cancelClosePopup(val) {
      this.isPopupVisible = val;
      this.cancelTxt = "Common_Cancel";
      this.confirmTxt = "Common_Confirm";
      this.isShowClose = false;
    },
    // mt4选择
    selectChange(val) {
      this.brokerList.forEach((item, index) => {
        if (item.id == val) {
          this.serverList = item.serverList;
        }
      });
    },
    labelIconClick(title, content, subContent) {
      if (this.mobileFlag) {
        this.isLableTips = !this.isLableTips;
        this.labelTitle = title;
        this.labelTxt = content;
        this.labelSubContent = subContent;
      } else {
        this.isLableTips = false;
      }
    },
    screenClick() {
      // debugger
      document.addEventListener("click", (e) => {
        if (this.$refs.mobileLabelTips) {
          let self = this.$refs.mobileLabelTips.contains(e.target);
          if (!self) {
            this.isLableTips = false;
            this.labelSubContent = "";
          }
        }
        if (this.$refs.refuseCard) {
          let self = this.$refs.refuseCard.contains(e.target);
          if (!self) {
            this.isRefuse = false;
          }
        }
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("Common_Total");
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          column.property === "profit" ||
          column.property === "currentPeriodVolumes" ||
          column.property === "equity" ||
          column.property === "balance"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = formatNumberFractionDigits(sums[index]);
        } else {
          sums[index] = " ";
        }
      });

      return sums;
    },
    cancelStop() {
      this.$refs.stopForm.resetFields();

      this.stopDialogVisible = false;
    },
    stopSubmit() {
      if (this.stopCheckbox) {
        this.cancelStopPopup();
      } else {
        this.$notify.error({
          title: this.$t("Common_Prompt"),
          message: this.$t("StopFollow_CheckNotNull"),
        });
      }
    },
    // 跟单比例设置
    percentSetting() {
      this.btnType = 2;
      this.clickType = "percentSetting";
      this.popupContent = "Setting_PercentSettingContent";
      this.isHtml = true;
      this.isPopupVisible = true;
    },
    // 确认跟单比例设置
    confirmPercentSetting() {
      this.fullscreenLoading = true;
      var params = {
        id: this.checkRow.id,
        followRate: this.followForm.following,
      };
      this.$axios
        .post("/Api/Invite/SetFollowRate", params)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });
            this.getData(this.currentPage, this.pageSize);
            this.$refs.followForm.resetFields();
            this.checkInviteDrawer = false;
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.formLots {
  right: 12%;
}
.pageTitle {
  justify-content: flex-start;
  align-items: center;
}
.refreshListBtnDiv {
  margin-left: 10px;
  .confirmDialogBtn {
    color: #fff;
    text-align: center;
    font-family: "PingFangSC-Medium";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    padding: 8px 10px;
  }
}
.stopCheckbox {
  color: #e35972;
  font-size: 20px;
}

@media screen and (max-width: 767px) {
  .tableDiv {
    padding-top: 40px !important;
  }
  .scrollLoading {
    height: 50px;
    text-align: center;
  }
}
</style>
